import { configureStore } from '@reduxjs/toolkit'
import combinedReducers from 'store/reducer'
import { projectMiddleware } from 'store/middleware/projectMiddleware'
import { thumbnailMiddleware } from 'store/middleware/thumbnailMiddleware'
import { aiLibMiddleware } from 'store/middleware/aiLibMiddleware'
import * as Sentry from '@sentry/react'
import projectDataUndoMiddleware from 'store/middleware/projectDataUndoMiddleware'

const sentryReduxEnhancer = Sentry.createReduxEnhancer()

const environmentSubMap = {
  Staging: 'stage',
  Development: 'local',
  Local: 't'
}

const subs = Object.entries(environmentSubMap)
const sub = subs.find(sub => window.location.hostname.includes(sub[1]))
const devToolsEnabled = !!sub

const store = configureStore({
  reducer: combinedReducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware()
      .concat(projectDataUndoMiddleware)
      .concat(projectMiddleware)
      .concat(thumbnailMiddleware)
      .concat(aiLibMiddleware),
  enhancers: getDefaultEnhancers => {
    return getDefaultEnhancers().concat(sentryReduxEnhancer)
  },
  devTools: devToolsEnabled
    ? {
        name: `V-Editor - ${sub[0]}`
      }
    : false
})

export default store

export const dispatch = store.dispatch
